import { createContext } from 'react';

const agregarReqContext = createContext();

export default agregarReqContext;